import { CollectionPlay } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import { getCdnUrl } from '@/helpers';
import { IHighlightsPackage } from '@/interfaces/packages';
import styled, { StyledProp } from '@/styled';

interface Props extends StyledProp, Partial<IHighlightsPackage> {
  packageSize: number;
}

const MyPackagesCard = ({ className, ...props }: Props) => {
  const navigate = useNavigate();

  const { image, image_first_course, hash = '' } = props;
  const currentImage = getCdnUrl(image, image_first_course);

  return (
    <div className={className}>
      <BaseCard
        image={{ aspect: '16:9', src: currentImage }}
        id={`package-card-${hash}`}
        onClick={() => navigate(`/pacote/${hash}`)}
        internalSpace={8}
      >
        <Typography.Title className={'package-title'} level={4}>
          {props.title}
        </Typography.Title>
        <div className='package-size-container'>
          <CollectionPlay size={20} className='packages-size-icon' />
          <Typography.Text className='packages-size-text'>{`${props.packageSize} cursos`}</Typography.Text>
        </div>
      </BaseCard>
    </div>
  );
};

export default styled(MyPackagesCard)`
  overflow: visible !important;

  .base-card {
    transition: border-color 300ms;
  }

  .ant-typography.package-title {
    margin-bottom: 0;
  }

  .packages-size-icon {
    color: ${({ theme }) => theme.colorTextTertiary};
  }

  .base-card-data span.packages-size-text {
    font-size: 14px;
    color: ${({ theme }) => theme.colorTextTertiary};
  }

  .package-size-container {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  .status {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: calc(100% - 105px);
    top: 0px;
    left: 0;
    z-index: 2;

    svg {
      color: ${({ theme }) => theme.colorIcon};
      filter: drop-shadow(0px 0px 16px rgb(0 0 0 / 1));
    }
  }
`;
